'use client';

import React, { useState } from "react";
import Image from "next/image";

import AccountDropdown from "../../Dropdowns/AccountDropdown/AccountDropdown";
import Icon from "../Icon/Icon";
import MobileNavigation from "./MobileNavigation/MobileNavigation";
import Link from "../../NextJs/Link";

import styles from "./Header.module.css";

interface Props {
    mobileLogo: string;
    desktopLogo: string;
    children?: React.ReactNode;
}

export default function Header({ mobileLogo, desktopLogo, children }: Props) {
    const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false);

    const handleClose = () => {
        setIsMobileNavigationOpen(false);
    }

    const handleOpen = () => {
        setIsMobileNavigationOpen(true);
    }

    return (
        <header className={styles.header}>
            <MobileNavigation
                logo={mobileLogo}
                isOpen={isMobileNavigationOpen}
                onClose={handleClose}
                links={[
                    {
                        href: '/',
                        icon: 'key',
                        label: 'Admin Management',
                    },
                    {
                        href: '/customers',
                        icon: 'users',
                        label: 'Customers'
                    },
                    {
                        href: '/sub-contractors',
                        icon: 'wrench',
                        label: 'Subcontractors'
                    },
                ]}
            >
                {children}
            </MobileNavigation>
            <Link href="/" title="Dashboard" className="h-[28px] mr-auto">
                <Image
                    src={desktopLogo}
                    width={110}
                    height={54}
                    alt="Vergo"
                />
            </Link>
            <AccountDropdown />
            <button
                type="button"
                className="flex gap-050 items-center p-075 -mr-075 min-[860px]:hidden"
                onClick={handleOpen}
            >
                <Icon icon="menu" size="large" />
                <span className="type-small-caps pt-0125 hidden min-[540px]:block">Menu</span>
            </button>
        </header>
    );
};
